import React, { useState } from "react";
import ContactForm from "../ContactForm/ContactForm";
import { TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import "./Overview.css";

const Overview = ({
  clubData,
  imageUrl,
  setIsLoading,
  isLoading,
  send,
  setImageUrl,
}) => {
  const [next, setNext] = useState(false);

  const [formData, setFormData] = useState({
    msg: "",
  });

  const [charCount, setCharCount] = useState(55); // Limite de caractères

  const handleNext = async () => {
    setNext(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Limiter la longueur du message à 55 caractères
    if (value.length <= 55) {
      setFormData({
        ...formData,
        [name]: value,
      });

      // Mettre à jour le compteur de caractères restants
      setCharCount(55 - value.length);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleNext();
  };

  return (
    <>
      {!next ? (
        <div className="overview">
          <div className="title">Ajouter une photo</div>
          <img
            src={imageUrl}
            alt="user selfie"
            onLoad={() => setIsLoading(false)}
            style={{ display: isLoading ? "none" : "block" }}
          />
          <form
            style={{
              color: `${clubData.textColor}`,
            }}
            onSubmit={handleSubmit}
          >
            {clubData.withText && (
              <>
                <TextField
                  label={
                    <span>
                      Votre Message{" "}
                      <Typography
                        component="span"
                        variant="caption" // Taille plus petite pour le texte entre parenthèses
                        style={{ fontSize: "0.75rem" }}
                      >
                        ({charCount} caractères restants)
                      </Typography>
                    </span>
                  }
                  name="msg"
                  value={formData.msg}
                  onChange={handleChange}
                  fullWidth
                  margin="dense"
                  required
                  inputProps={{ maxLength: 55 }} // Limite de caractères côté input
                  InputProps={{
                    style: {
                      color: `${clubData.textColor}`, // Couleur du texte de l'input
                    },
                    notchedOutline: {
                      borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: `${clubData.btnColor}`, // Appliquer la couleur de btnColor au fieldset
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      color: `${clubData.textColor}`, // Couleur du label (placeholder au-dessus)
                    },
                  }}
                />
              </>
            )}
            <Button
              type="submit"
              variant="contained"
              style={{
                backgroundColor: `${clubData.btnColor}`,
                color: `${clubData.textColor}`,
              }}
            >
              Suivant
            </Button>
          </form>
        </div>
      ) : (
        <ContactForm
          send={send}
          setImageUrl={setImageUrl}
          clubData={clubData}
          message={formData.msg}
        />
      )}
    </>
  );
};

export default Overview;
